export const btnReset = `
  border: none;
  cursor: pointer;
  background: none;
  &:hover,
  &:focus,
  &:active {
    outline: none;
  }
`;

export const flexCenter = `
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const singleLineText = `
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const circle = (radius: number) =>
  `
    border-radius: 50%;
    width: ${radius}px;
    height: ${radius}px;
  `;

export const inputPlaceholder = (color: string) =>
  `
    &::-webkit-input-placeholder {
      color: ${color};
      opacity: 1;
    }
    &::-moz-placeholder {
      color: ${color};
      opacity: 1;
    }
    &:-ms-input-placeholder {
      color: ${color};
      opacity: 1;
    }
    &:-moz-placeholder {
      color: ${color};
      opacity: 1;
  }
`;

// flex and min-height don't work in IE11
export const minHeight100vh = () => {
  //@ts-ignore
  const isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
  if (isIE11) {
    return `height: ${window.innerHeight}px;`;
  } else {
    return 'min-height: 100vh;';
  }
};
